// extracted by mini-css-extract-plugin
export var button = "_co-4";
export var hasDarkBackground = "_co-7";
export var hasLightBackground = "_co-6";
export var iconWrapper = "_co-0";
export var large = "_co-2";
export var medium = "_co-1";
export var small = "_co-5";
export var xsmall = "_co-3";